// TODO: Make this more accurate instead of assuming `starts with vowel => 'an'` (we need to handle words that start with a vowel sound -- not just a vowel letter)
/** A very inaccurate implementation of appropriate indefinite article determination (i.e. should we use `a` or `an` for a given word) */
export function indefiniteArticle(value) {
  if (
    value &&
    typeof value === 'string' &&
    value.length > 0 &&
    ['a', 'e', 'i', 'o', 'u'].includes(value.charAt(0).toLowerCase())
  ) {
    return 'an';
  }

  return 'a';
}
